import I18n from 'I18n';
import { NavMarker } from 'react-rhumb';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { ListingPage } from 'foundations-components/transitional/components/ListingPage';
import { Header } from 'foundations-components/transitional/components/Header';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const ProhibitedDashboard = ({
  type = 'notFound',
  message = I18n.text('error.notFound.message')
}) => /*#__PURE__*/_jsx(ListingPage, {
  "data-test-id": "prohibited-dashboard",
  headerComponent: /*#__PURE__*/_jsx(Header, {
    title: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "error.header.title"
    }),
    use: "condensed",
    flush: true
  }),
  children: /*#__PURE__*/_jsx(NavMarker, {
    name: "PROHIBITED_PAGE_CONTAINER",
    children: /*#__PURE__*/_jsx(ErrorMessage, {
      type: type,
      children: /*#__PURE__*/_jsx("p", {
        children: message
      })
    })
  })
});
export default ProhibitedDashboard;